// This file is automatically generated by the sync-app-options script.
// Do not edit this file directly.
export const REVIEWABLE_DOCUMENT_TYPE_PREFIX = 'translation:reviewable_document_type';
// i18n.t('translation:reviewable_document_type.english_translation_of_proof_of_address', 'Proof of Address: Certified or notarized English or Portuguese translation')
// i18n.t('translation:reviewable_document_type.birth_certificate', 'Birth Certificate')
// i18n.t('translation:reviewable_document_type.proof_of_custody', 'Proof of Custody (for minor with a single parent)')
// i18n.t('translation:reviewable_document_type.valid_id_with_self_declaration_for_first_name_only', 'Valid ID with self-declaration for first name ONLY')
// i18n.t('translation:reviewable_document_type.passport_signature_page', 'Passport Signature Page')
// i18n.t('translation:reviewable_document_type.eu_id_card', 'EU ID Card')
// i18n.t('translation:reviewable_document_type.bank_statement', 'Bank Statement')
// i18n.t('translation:reviewable_document_type.bank_verification_letter', 'Bank Verification Letter (for proof of address)')
// i18n.t('translation:reviewable_document_type.signed_power_of_attorney', 'Signed Power of Attorney')
// i18n.t('translation:reviewable_document_type.other_additional_document', 'Other Additional Document')
// i18n.t('translation:reviewable_document_type.driver_license', 'Driver License')
// i18n.t('translation:reviewable_document_type.proof_of_name_change', 'Proof of Name Change with Valid ID')
// i18n.t('translation:reviewable_document_type.utility_bill', 'Utility Bill')
// i18n.t('translation:reviewable_document_type.portuguese_birth_certificate', 'Portuguese Birth Certificate')
// i18n.t('translation:reviewable_document_type.english_translation_of_birth_certificate', 'Birth Certificate: Certified or notarized English or Portuguese translation')
// i18n.t('translation:reviewable_document_type.passport', 'Passport')
// i18n.t('translation:reviewable_document_type.valid_id_with_self_declaration_for_last_name_only', 'Valid ID with self-declaration for last name ONLY')
export const REVIEWABLE_DOCUMENT_TYPES = {
    english_translation_of_proof_of_address: {
        id: '3d12d035-c093-44f9-8585-ef6938d46930',
        name: 'Proof of Address: Certified or notarized English or Portuguese translation',
        description: 'English or Portuguese translation of your Proof of Address. The translation needs to be certified by a lawyer or a notary.',
        key: 'english_translation_of_proof_of_address',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    birth_certificate: {
        id: '9c25c142-9f83-4c38-ad6f-ec2d17678ba8',
        name: 'Birth Certificate',
        key: 'birth_certificate',
        hasTwoFiles: false,
        categories: ['0c5d7034-a87f-4049-a178-33a73277a2d1'],
    },
    proof_of_custody: {
        id: 'b3db26d2-fbee-412e-9a72-93bf46ec978f',
        name: 'Proof of Custody (for minor with a single parent)',
        description: 'If you’re a single parent, provide proof of custody / death certificate of Parent 2.',
        key: 'proof_of_custody',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    valid_id_with_self_declaration_for_first_name_only: {
        id: '9442d5fe-4941-46aa-be81-6692f107b184',
        name: 'Valid ID with self-declaration for first name ONLY',
        description: 'A valid government ID along with a self-written letter confirming that you only go by your first name as seen on your passport.',
        key: 'valid_id_with_self_declaration_for_first_name_only',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    passport_signature_page: {
        id: '6b66724d-f648-4bd3-9cb5-00adf6f72d0f',
        name: 'Passport Signature Page',
        description: 'Clear copy of your passport’s signature page',
        key: 'passport_signature_page',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    eu_id_card: {
        id: '63f4b91c-46d5-4f4a-ac59-572987d6a9d9',
        name: 'EU ID Card',
        description: 'Upload a high-quality scan or photo of the EU National ID card.',
        key: 'eu_id_card',
        hasTwoFiles: true,
        categories: [
            '799839d3-f45b-4ab3-8a85-dcf05fa346b3',
            '78ad4904-3f1b-46bf-b63d-3418897253ae',
        ],
    },
    bank_statement: {
        id: 'ff57ca3a-152a-4b3b-be35-66c83304db16',
        name: 'Bank Statement',
        key: 'bank_statement',
        hasTwoFiles: false,
        categories: ['1093ba34-5740-45fb-8edd-57a69da0bf7e'],
    },
    bank_verification_letter: {
        id: 'fb1ae78b-cd9d-4091-b5fe-489890d602de',
        name: 'Bank Verification Letter (for proof of address)',
        description: 'Please provide a bank verification letter that includes your complete address as a supporting document to your bank statement.',
        key: 'bank_verification_letter',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    signed_power_of_attorney: {
        id: 'fb2fba19-bf3e-44d1-b252-01633c10db59',
        name: 'Signed Power of Attorney',
        key: 'signed_power_of_attorney',
        hasTwoFiles: false,
        categories: ['33b05084-309b-4fd5-af28-a4e83582d3df'],
    },
    other_additional_document: {
        id: '63d8826c-e93b-4d2c-8179-f12f9cb526db',
        name: 'Other Additional Document',
        key: 'other_additional_document',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    driver_license: {
        id: '129053ce-ff62-4439-8c35-3967af8f97a6',
        name: 'Driver License',
        key: 'driver_license',
        hasTwoFiles: true,
        categories: ['1093ba34-5740-45fb-8edd-57a69da0bf7e'],
    },
    proof_of_name_change: {
        id: '4732c5b3-c645-445c-bbb6-7d4e1c04cf78',
        name: 'Proof of Name Change with Valid ID',
        description: 'Please provide proof of your name change along with a valid government ID that shows your current name.',
        key: 'proof_of_name_change',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    utility_bill: {
        id: '84233c39-e66e-4be3-a5fb-a02e72af12e4',
        name: 'Utility Bill',
        key: 'utility_bill',
        hasTwoFiles: false,
        categories: ['1093ba34-5740-45fb-8edd-57a69da0bf7e'],
    },
    portuguese_birth_certificate: {
        id: '7ed2ccbf-cf2a-44f9-99fd-4a64da651104',
        name: 'Portuguese Birth Certificate',
        key: 'portuguese_birth_certificate',
        hasTwoFiles: false,
        categories: ['cb86742b-d961-4aef-bc48-f4266ac25b8f'],
    },
    english_translation_of_birth_certificate: {
        id: '8b03fb77-3743-4714-84df-0315ec148972',
        name: 'Birth Certificate: Certified or notarized English or Portuguese translation',
        description: 'English or Portuguese translation of your Birth Certificate. The translation needs to be certified by a lawyer or a notary.',
        key: 'english_translation_of_birth_certificate',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
    passport: {
        id: 'ed5accfb-e5fe-45f1-8beb-9f1a46ef38b9',
        name: 'Passport',
        description: 'Upload a high-quality scan or photo of the passport.',
        key: 'passport',
        hasTwoFiles: false,
        categories: [
            '799839d3-f45b-4ab3-8a85-dcf05fa346b3',
            '78ad4904-3f1b-46bf-b63d-3418897253ae',
        ],
    },
    valid_id_with_self_declaration_for_last_name_only: {
        id: '1bef3e2d-1ad7-4769-bf60-3ff09c5fa028',
        name: 'Valid ID with self-declaration for last name ONLY',
        description: 'A valid government ID along with a self-written letter confirming that you only go by your last name as seen on your passport.',
        key: 'valid_id_with_self_declaration_for_last_name_only',
        hasTwoFiles: false,
        categories: ['4ea1e578-a318-42f3-80f0-f18953de62e8'],
    },
};
export const REVIEWABLE_DOCUMENT_TYPE_DESCRIPTION_PREFIX = 'translation:reviewable_document_type_description';
// i18n.t('translation:reviewable_document_type_description.english_translation_of_proof_of_address', 'English or Portuguese translation of your Proof of Address. The translation needs to be certified by a lawyer or a notary.')
// i18n.t('translation:reviewable_document_type_description.proof_of_custody', 'If you’re a single parent, provide proof of custody / death certificate of Parent 2.')
// i18n.t('translation:reviewable_document_type_description.valid_id_with_self_declaration_for_first_name_only', 'A valid government ID along with a self-written letter confirming that you only go by your first name as seen on your passport.')
// i18n.t('translation:reviewable_document_type_description.passport_signature_page', 'Clear copy of your passport’s signature page')
// i18n.t('translation:reviewable_document_type_description.eu_id_card', 'Upload a high-quality scan or photo of the EU National ID card.')
// i18n.t('translation:reviewable_document_type_description.bank_verification_letter', 'Please provide a bank verification letter that includes your complete address as a supporting document to your bank statement.')
// i18n.t('translation:reviewable_document_type_description.proof_of_name_change', 'Please provide proof of your name change along with a valid government ID that shows your current name.')
// i18n.t('translation:reviewable_document_type_description.english_translation_of_birth_certificate', 'English or Portuguese translation of your Birth Certificate. The translation needs to be certified by a lawyer or a notary.')
// i18n.t('translation:reviewable_document_type_description.passport', 'Upload a high-quality scan or photo of the passport.')
// i18n.t('translation:reviewable_document_type_description.valid_id_with_self_declaration_for_last_name_only', 'A valid government ID along with a self-written letter confirming that you only go by your last name as seen on your passport.')
//# sourceMappingURL=reviewable-document-type.js.map